import { useEffect, useRef } from 'react';
import { trackScrollDepth, isAnalyticsEnabled } from '../utils/analytics';

const THRESHOLDS = [25, 50, 75, 100] as const;

export function useScrollDepth(): void {
  const firedThresholds = useRef<Set<number>>(new Set());

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;

    function handleScroll(): void {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;

      if (docHeight <= 0) return;

      const scrollPercent = (scrollTop / docHeight) * 100;

      for (const threshold of THRESHOLDS) {
        if (scrollPercent >= threshold && !firedThresholds.current.has(threshold)) {
          firedThresholds.current.add(threshold);
          trackScrollDepth(threshold);
        }
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
}
